import axios from "axios";

export const downloadCuttingChallanGeneratedAllReport = async (inputs) => {
  if (inputs.from == undefined) {
    inputs.from = "";
  }
  if (inputs.to == undefined) {
    inputs.to = "";
  }

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/cutting-challan-generate-excel?from=${inputs.from}&to=${inputs.to}`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    return error?.response?.data?.result;
  }
};
